import { Datatype } from "./datatype.enum";
import { ColumnProperties } from "./ColumnProperties";

export class Column{
    active:boolean;
    ColumnID:number;
    ColumnName:string;
    Datatype:string;
    Lookup:boolean;
    Primary:boolean;
      // Readonly: boolean;
      // Nullable: boolean;
      sameasobjectpermission: boolean;
    Properties:ColumnProperties;
    parentObject:any;
    label:string;
    Multiselect:boolean;

}
